import PropTypes from 'prop-types';
import { Link } from 'src/common/components/shared/link/Link';
import Text from '../Text';

import getLinks from './getLinks';
import css from './links.module.scss';

function generateLinks(settingsTabList, selectedTab) {
  const links = [];

  settingsTabList.forEach((tabDefinition) => {
    const tabName = tabDefinition.name;
    const id = `${tabName}SettingsTab`;

    if (tabName === selectedTab) {
      links.push(
        <p key={id} data-testid={id} className={css.activeLink}>
          <Text name={tabName} />
        </p>,
      );
    } else {
      links.push(
        <Link key={id} data-testid={id} className={css.nonActiveLink} to={tabDefinition.path}>
          <Text name={tabName} />
        </Link>,
      );
    }
  });

  return links;
}

const Links = ({ selectedTab, showSubscriptionTab }) => {
  const settingsTabList = getLinks(showSubscriptionTab);

  return (
    <div data-testid="accountSettingsLinks" className={css.linksWrapper}>
      {generateLinks(settingsTabList, selectedTab)}
    </div>
  );
};

Links.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  showSubscriptionTab: PropTypes.bool.isRequired,
};

export default Links;
